<template>
  <div class="">
    <div class="main-header">

      <div class="main-header-text rellax" data-rellax-speed="1">
        <span class="main-header-headline">{{ headerText }}</span>
        <span class="main-header-body">{{ subheaderText }}</span>
      </div>

      <div class="header-logos">
        <img :src="getImgUrl(brand)" v-for="brand in logos" class="header-brand-logo">
      </div>
    </div>

    <div class="vertical-page-demo-block" v-for="demo in pageData.demos" :style="`background-color: ${demo.backgroundColor}`">

      <span class="vertical-inline-element" v-if="demo.orientation == 'left'">
        <PhoneAndVideoComponent :demo="demo" ></PhoneAndVideoComponent>
      </span>

      <span class="vertical-inline-element desktop-element vertical-element-details">

        <div class="vertical-attach-type-used">
          <!-- <img class="brand-logo" :src="`//mikmak.s3.amazonaws.com/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/${demo.brand}.png`" alt=""> -->
          Attach <span :class="`attach-product-badge badge-for-${demo.attachProduct}`">{{ demo.attachProduct }}</span>
        </div>

        <div class="vertical-element-headline" v-html="demo.headline"></div>

        <div class="vertical-element-text" v-for="textItem in demo.text" v-html="textItem"></div>

        <ul class="vertical-element-text">
          <li class="vertical-element-bullet" v-for="bullet in demo.bullets" v-html="bullet"></li>
        </ul>

        <a href="#contact-footer" v-on:click="clickedRequestDemoButton(demo)" class="attach-item-request-demo-button">Request a demo</a>

      </span>

      <span class="vertical-inline-element" v-if="demo.orientation == 'right'">
        <PhoneAndVideoComponent :demo="demo"></PhoneAndVideoComponent>
      </span>

      <span class="vertical-inline-element mobile-element vertical-element-details">

        <div class="vertical-attach-type-used">
          Attach <span :class="`attach-product-badge badge-for-${demo.attachProduct}`">{{ demo.attachProduct }}</span>
        </div>

        <div class="vertical-element-headline" v-html="demo.headline"></div>

        <div class="vertical-element-text" v-for="textItem in demo.text" v-html="textItem"></div>

        <a href="#contact-footer" v-on:click="clickedRequestDemoButton(demo)" class="attach-item-request-demo-button">Request a demo</a>

      </span>
    </div>
  </div>
</template>

<script>

import Rellax from 'rellax'
import eventDispatcher from '../../events/dispatch'

import PhoneAndVideoComponent from './PhoneAndVideoComponent'

export default {
  components: {
    PhoneAndVideoComponent
  },
  mounted() {
    let rellax = new Rellax('.rellax');
  },
  methods: {
    clickedRequestDemoButton(demo) {
      let message = `Requested demo from Attach industry/solution page ${this.vertical}`

      if (!window.mmProductInterests) window.mmProductInterests = []
      window.mmProductInterests.push(message)

      eventDispatcher('requestDemoClicked', {
        sourceOfDemo: demo.clickMessage
      })

      this.resetScroll()
    },
    resetScroll() {
      setTimeout(() => {
        window.scrollBy(0, -48)
      }, 10)
    },
    getImgUrl(brand) {
      var images = require.context('../../assets/brand-logos/')
      return images(`./${brand}.png`)
      // return `//mikmak.s3.amazonaws.com/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/${brand}.png`
    }
  },
  computed: {
    vertical() {
      return this.$route.params.vertical
    },
    pageData() {
      if (this.$store.state.verticalPageData[this.vertical]) {
        return this.$store.state.verticalPageData[this.vertical]
      }

      return this.$store.state.verticalPageData['apparel-and-footwear']
    },
    headerText() {
      return this.pageData && this.pageData.title
    },
    subheaderText() {
      return this.pageData && this.pageData.subtitle
    },
    logos() {
      return this.pageData && this.pageData.logos
    },
    partnerList() {
      return this.$store.state.partnerList
    },
    partnerCount() {
      return this.partnerList && this.partnerList.length
    },
    halfPartners() {
      if (this.partnerCount) return parseInt(this.partnerCount / 2)
    }
  },
  watch: {}
}
</script>

<style scoped>

  .main-header {
    font-family: 'Work Sans', sans-serif;
    display: block;
    width: 100%;
    overflow: hidden;
    position: relative;
  }

  .header-text-button {
    background: #409dd4; /* Old browsers */
    background: #00a9bc; /* Old browsers */
    background: -moz-linear-gradient(-45deg, #00a9bc 0%, #00b5bf 69%, #00bfbd 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(-45deg, #00a9bc 0%,#00b5bf 69%,#00bfbd 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00a9bc', endColorstr='#00bfbd',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
    color: white;
    font-size: 22px;
    width: 224px;
    text-align: center;
    padding: 8px;
    border-radius: 3px;
    margin: 0 auto;
    margin-top: 24px;
    display: block;
    cursor: pointer;
    box-shadow: 0px 2px 6px #00000024;
    font-weight: lighter;
    text-decoration: none;
  }

  .main-header-headline {
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: block;
    padding-top: 150px;
    text-align: center;
    font-size: 40px;
  }

  @media only screen and (max-width: 850px) {
    .main-header-headline {
      padding-top: 80px;
    }
  }

  @media only screen and (max-width: 650px) {
    .main-header-headline {
      width: 80%;
      text-align: center;
      margin: 0 auto;
      font-size: 32px;
    }
  }

  .main-header-body {
    text-align: center;
    display: block;
    font-size: 16px;
    width: 700px;
    margin: 12px auto;
    color: #737373cf;
  }

  @media only screen and (max-width: 650px) {
    .main-header-body {
      width: 90%;
      font-size: 14px;
    }
  }

  /* IMAGE STYLES */

  .marley-image {
    position: absolute;
    left: -341px;
    top: 100px;
    width: 650px;
    pointer-events: none;
  }

  .magnetight-image {
    position: absolute;
    right: -270px;
    top: 139px;
    width: 576px;
    pointer-events: none;
  }

  .ua-shoes-image {
    position: absolute;
    left: -145px;
    top: 95px;
    width: 250px;
    pointer-events: none;
  }

  .fuji-image {
    width: 300px;
    top: 75px;
    position: absolute;
    right: -114px;
    pointer-events: none;
  }

  @media only screen and (max-width: 1200px) {
    .marley-image {
      left: -311px;
      top: 90px;
    }

    .magnetight-image {
      right: -240px;
      top: 200px;
      width: 550px;
    }

    .ua-shoes-image {
      display: none;
    }

    .fuji-image {
      width: 300px;
      top: 100px;
      position: absolute;
      right: -120px;
    }
  }


  @media only screen and (max-width: 850px) {
    .ua-shoes-image {
      display: none;
    }
    .magnetight-image {
      top: 300px;
    }
    .fuji-image {
      top: 200px;
    }
  }

  @media only screen and (max-width: 650px) {
    .marley-image {
      top: 213px;
    }
    .magnetight-image {
      top: 452px;
      right: -214px;
    }
    .fuji-image {
      top: 336px;
      right: -159px;
    }
  }

  .partner-logo {
    width: 100px;
    margin: 12px 90px;
    opacity: 0.04;
  }

  .partner-logos {

  }

  .homepage-promobar {
    display: block;
    text-align: center;
  }

  .homepage-promobar span {
    overflow: hidden;
    display: inline-block;
    margin: 0 auto;
    text-align: center;
    margin-top: 200px;
    background: #0000000f;
    border-radius: 50px;
    padding: 4px 32px;
    color: #00BFBD;
    font-size: 13px;
  }

  .homepage-promobar span label {
    padding: 4px 24px;
    color: white;
    background: #00BFBD;
    border-radius: 50px;
    margin-left: 24px;
  }

  @media only screen and (max-width: 850px) {
    .homepage-promobar span {
      margin-top: 100px;
    }
  }

  @media only screen and (max-width: 650px) {
    .homepage-promobar span {
      display: none;
    }
  }

  .homepage-partners {
    font-size: 16px;
    margin: 0 auto;
    display: block;
    text-align: center;
    margin-top: 224px;
  }

  .partner-badges {
    width: 450px;
  }

  @media only screen and (max-width: 850px) {
    .homepage-partners {
      margin-top: 80px;
      font-size: 14px;
    }
    .partner-badges {
      width: 400px;
    }
  }

  @media only screen and (max-width: 650px) {
    .homepage-partners {
      font-size: 10px;
    }
    .partner-badges {
      width: 300px;
    }
  }

  .header-text-button-light {
    background: -moz-linear-gradient(-45deg, #00a9bc 0%, #00b5bf 69%, #00bfbd 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(-45deg, #00a9bc 0%,#00b5bf 69%,#00bfbd 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: block;
    font-size: 14px;
    text-align: center;
    margin: 14px auto;
    width: 224px;
    border-radius: 2px;
    padding: 6px;
    cursor: pointer;
    text-decoration: none;
  }

  .vertical-inline-element {
    display: inline-block;
    width: 35%;
    margin: 24px auto;
    vertical-align: top;
  }

  @media only screen and (max-width: 650px) {
    .vertical-inline-element {
      display: block;
      width: 100%;
    }
  }

  .vertical-page-demo-block {
    font-size: 14px;
    text-align: center;
    white-space: nowrap;
    display: block;
    margin: 48px 0;
    padding: 0px 100px;
  }

  @media only screen and (max-width: 650px) {
    .vertical-page-demo-block {
      margin: 0 auto;
      padding: 24px;
    }
  }

  .vertical-element-details {
    text-align: left;
    max-width: 320px;
    white-space: normal;
  }

  .vertical-element-headline {
    font-family: 'Work Sans', sans-serif;
    margin-top: 24px;
    margin-left: 2px;
    font-size: 24px;
  }

  .vertical-element-text {
    font-family: 'Work Sans', sans-serif;
    margin: 16px 4px;
    white-space: normal;
    line-height: 22px;
    color: #717171;
  }

  .vertical-attach-type-used {
    font-family: 'Work Sans', sans-serif;
    margin-top: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #b1b0b0;
    font-size: 16px;
  }

  @media only screen and (max-width: 650px) {
    .vertical-attach-type-used {
      margin-top: 48px;
      text-align: center;
    }
  }

  .attach-product-badge {
    padding: 2px 8px;
    border-radius: 2px;
    text-align: left;
    padding-left: 10px;
    background: black;
  }

  .badge-for-cart {
    background: #0088bc;
    color: white;
  }

  .badge-for-multicart {
    background: #925eef;
    color: white;
  }

  .badge-for-review {
    background: #4ac177;
    color: white;
  }

  .attach-item-request-demo-button {
    background: #409dd4;
    background: #00a9bc;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00a9bc', endColorstr='#00bfbd',GradientType=1 );
    color: white;
    font-size: 22px;
    text-align: center;
    padding: 8px;
    border-radius: 3px;
    margin-top: 24px;
    display: block;
    cursor: pointer;
    box-shadow: 0px 2px 6px #00000024;
    font-weight: lighter;
    text-decoration: none;
    letter-spacing: 1px;
  }

  .desktop-element {
    display: inline-block;
  }

  .mobile-element {
    display: none;
  }

  @media only screen and (max-width: 650px) {
    .desktop-element {
      display: none;
    }
    .mobile-element {
      display: block;
    }
  }

  .brand-logo {
    width: 134px;
    opacity: 0.25;
    margin-top: 27px;
  }

  .header-logos {
    display: block;
    text-align: center;
    width: 90%;
    margin: 0 auto;
    margin-top: 48px;
  }

  .header-brand-logo {
    display: inline-block;
    width: 80px;
    margin: 12px;
  }

</style>



// WEBPACK FOOTER //
// AttachVerticalHeaderComponent.vue?f2fb8d9c